import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y2028 = new LunarYear(
  moment.tz('2028-01-27 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 11, 12],
  [29, 30, 30, 29, 30, 29, 29, 30, 29, 29, 30, 30, 29],
  5,
)

export default Y2028
